import React, { useState } from 'react';
import { Search } from 'lucide-react';

const AddNewSkill = ({ skills, handleAdd, handleExit }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedSkill, setSelectedSkill] = useState(null);
  const [showDropdown, setShowDropdown] = useState(false);

  const filteredSkills = skills.filter(skill =>
    skill.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleSkillSelect = (skill) => {
    setSelectedSkill(skill);
    setSearchTerm(skill.name);
    setShowDropdown(false);
  };

  const handleSubmit = () => {
    if (selectedSkill) {
      const newSkill = {
        name: selectedSkill.name,
        skill_id: selectedSkill.id,
        in_rig: 0,
        to_pit: 0,
        mat_with_catch: 0,
        to_mat: 0,
        to_bed: 0,
        in_combination: 0,
        in_routine: 0,
        competed: 0
      };
      handleAdd(newSkill);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-3xl shadow-2xl max-w-md w-full mx-4">
        {/* Header */}
        <div className="bg-gradient-to-r from-purple-600 to-blue-600 p-6 text-center rounded-t-3xl">
          <div className="text-4xl mb-2">🎯</div>
          <h2 className="text-3xl font-bold text-white drop-shadow-lg mb-1">
            Add New Skill
          </h2>
          <p className="p-style text-lg" style={{color: 'RGBA(255,255,255,0.9)'}}>
            Start tracking a new trampoline skill
          </p>
        </div>

        <div className="p-6 space-y-6">
          {/* Search Section */}
          <div className="relative">
            <h3 className="text-xl font-semibold text-gray-800 mb-3 text-center">
              Search Skills 🔍
            </h3>
            
            <div className="relative text-lg">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <Search className="h-5 w-5 text-gray-400" />
              </div>
              
              <input
                type="text"
                value={searchTerm}
                onChange={(e) => {
                  setSearchTerm(e.target.value);
                  setShowDropdown(true);
                  setSelectedSkill(null);
                }}
                onFocus={() => setShowDropdown(true)}
                placeholder="Search or select a skill..."
                className="w-full pl-10 pr-4 py-3 border-2 border-gray-200 rounded-xl focus:border-blue-500 focus:outline-none transition-colors duration-200 text-gray-800"
              />
              
              {showDropdown && searchTerm && (
                <div className="absolute z-10 w-full mt-1 bg-white border-2 border-gray-200 rounded-xl shadow-xl max-h-48 overflow-y-auto">
                  {filteredSkills.length > 0 ? (
                    filteredSkills.map((skill) => (
                      <button
                        key={skill.id}
                        onClick={() => handleSkillSelect(skill)}
                        className="w-full px-4 py-3 text-left hover:bg-blue-50 transition-colors duration-200 border-b border-gray-100 last:border-b-0 text-lg"
                      >
                        <div className="font-medium text-gray-800 text-lg">{skill.name}</div>
                      </button>
                    ))
                  ) : (
                    <div className="px-4 py-3 text-gray-500 text-center">
                      No skills found
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>

          {/* Selected Skill Preview */}
          {selectedSkill && (
            <div className="bg-gradient-to-r from-green-50 to-blue-50 rounded-xl p-4 border-2 border-green-200">
              <div className="flex items-center gap-3">
                <div className="w-3 h-3 bg-green-500 rounded-full"></div>
                <div>
                  <div className="font-semibold text-gray-800 text-lg">Selected:</div>
                  <div className="text-gray-600 text-lg">{selectedSkill.name}</div>
                </div>
              </div>
            </div>
          )}

          {/* Action Buttons */}
          <div className="flex gap-3 pt-2 text-lg">
            <button
              onClick={handleSubmit}
              disabled={!selectedSkill}
              className={`flex-1 font-semibold py-3 px-6 rounded-xl transition-all duration-200 shadow-lg flex items-center justify-center gap-2 ${
                selectedSkill
                  ? 'bg-green-500 hover:bg-green-600 text-white hover:scale-105 active:scale-95'
                  : 'bg-gray-300 text-gray-500 cursor-not-allowed'
              }`}
            >
              Add Skill 💾
            </button>
            
            <button
              onClick={handleExit}
              className="flex-1 bg-gray-500 hover:bg-gray-600 text-xl text-white font-semibold py-3 px-6 rounded-xl transition-all duration-200 hover:scale-105 active:scale-95 shadow-lg flex items-center justify-center gap-2"
            >
              Cancel ❌
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddNewSkill;